import { updateField } from 'vuex-map-fields';
import types from './mutations-types';

const mutations = {
  updateField,
  [types.SET_COMPANIES](state, payload) {
    state.companies = payload;
  },
  [types.SET_SYSTEM_COMPANIES](state, payload) {
    state.systemCompanies = payload;
  },
  [types.SET_ALL_COMPANIES](state, payload) {
    state.allCompanies = payload;
  },
  [types.SET_COMPANIES_USERS](state, payload) {
    state.myUsers = payload;
  },
  [types.SET_SEGMENTS](state, payload) {
    state.segments = payload;
  },
};

export default mutations;



// WEBPACK FOOTER //
// ./src/store/modules/master/mutations.js